<template>
  <div id="dashboard">
    <filters
      :monthRange="true"
      :region="true"
      @refresh="setParams"
      :dataSource="$t('filter.sourceAirdna')"
    />
    <loading v-if="loading" />
    <b-row class="mt-3" v-else>
      <b-col>
        <b-row class="mt-3">
          <b-col md="12">
            <b-row>
              <b-col lg="3" sm="6" xs="12">
                <SimpleEvoCard
                  v-if="this.kpis.bookings.actualBookings"
                  :title="this.kpis.bookings.title"
                  :value="this.kpis.bookings.actualBookings"
                  :evoReal="this.kpis.bookings.bookingsEvoReal"
                  :evoPercent="this.kpis.bookings.bookingsEvoPerc"
                />
              </b-col>
              <b-col lg="3" sm="6" xs="12">
                <SimpleEvoCard
                  v-if="this.kpis.overnights.actualOvernights"
                  :title="this.kpis.overnights.title"
                  :bubble="this.kpis.overnights.bubble"
                  :value="this.kpis.overnights.actualOvernights"
                  :evoReal="this.kpis.overnights.overnightsEvoReal"
                  :evoPercent="this.kpis.overnights.overnightsEvoPerc"
                />
              </b-col>
              <b-col lg="3" sm="6" xs="12">
                <SimpleEvoCard
                  v-if="this.kpis.lOfStay.actuallOfStay"
                  :title="this.kpis.lOfStay.title"
                  :bubble="this.kpis.lOfStay.bubble"
                  :value="this.kpis.lOfStay.actuallOfStay"
                  :evoReal="this.kpis.lOfStay.lOfStayEvoReal"
                  :evoPercent="this.kpis.lOfStay.lOfStayEvoPerc"
                />
              </b-col>
              <b-col lg="3" sm="6" xs="12">
                <SimpleEvoCard
                  v-if="this.kpis.occupation.actualOccupation"
                  :title="this.kpis.occupation.title"
                  :bubble="this.kpis.occupation.bubble"
                  :value="this.kpis.occupation.actualOccupation"
                  :evoReal="this.kpis.occupation.occupationEvoReal"
                  :evoPercent="this.kpis.occupation.occupationEvoPerc"
                  :mainPercent="true"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col md="6">
            <ChartCard
              v-if="this.evolutionChart.data[0].data"
              :title="$t('airdna.bookings_12_months')"
              :options="this.evolutionChart.options"
              :data="this.evolutionChart.data"
              :chartType="this.evolutionChart.type"
            />
          </b-col>
          <b-col md="6">
            <ChartCard
              v-if="this.overYearChart.data[0].data"
              :title="$t('airdna.evolution_overyear')"
              :options="this.overYearChart.options"
              :data="this.overYearChart.data"
              :chartType="this.overYearChart.type"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col md="6" sm="12">
            <ChartCard
              :title="this.$t('airdna.objectsAvailability')"
              v-if="objectsAvailability.data"
              :data="objectsAvailability.data"
              :chartType="objectsAvailability.type"
              :options="objectsAvailability.chartOptions"
              :period_info="this.$t('airdna.objectsAvailabilityComment')"
            />
          </b-col>
          <b-col md="6" sm="12">
            <ChartCard
              :title="this.$t('airdna.rentalActivity')"
              v-if="rentalActivity.data"
              :data="rentalActivity.data"
              :chartType="rentalActivity.type"
              :options="rentalActivity.chartOptions"
              :period_info="this.$t('airdna.rentalActivityComment')"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AirdnaMixins from "@/mixins/api/airdna";
import SimpleEvoCard from "@/components/dashboard/SimpleEvoCard";
import ChartCard from "@/components/dashboard/ChartCard";

export default {
  name: "AirdnaOffer",
  mixins: [AirdnaMixins],
  components: {
    ChartCard,
    SimpleEvoCard
  },
  data() {
    return {
      loading: true,
      kpis: {
        bookings: {
          actualBookings: null,
          bookingsEvoPerc: null,
          bookingsEvoReal: null,
          title: this.$t("airdna.nbBookings"),
        },
        overnights: {
          actualOvernights: null,
          overnightsEvoPerc: null,
          overnightsEvoReal: null,
          title: this.$t("airdna.estimatedOvernights"),
          bubble: this.$t("airdna.estimatedOvernightsComment"),
        },
        lOfStay: {
          actuallOfStay: null,
          lOfStayEvoPerc: null,
          lOfStayEvoReal: null,
          title: this.$t("airdna.lOfStay"),
          bubble: this.$t("airdna.lOfStayComment"),
        },
        occupation: {
          actualOccupation: null,
          occupationEvoPerc: null,
          occupationEvoReal: null,
          title: this.$t("airdna.occupation"),
          bubble: this.$t("airdna.occupationComment"),
        },
      },
      evolutionChart: {
        options: {
          chart: {
            id: "airdna_12Months",
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: this.$t("airdna.estimatedOvernights"),
            },
          },
          plotOptions: {
            bar: {
              dataLabels: {
                position: "top", // top, center, bottom
              },
            },
          },
          dataLabels: {
            enabledOnSeries: [0],
            offsetY: -15,
            style: {
              colors: ["#000"],
              fontSize: ".7rem",
            },
          },
          colors: ["#0984e3", "#c5eff7"],
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
        type: "bar",
        data: [
          {
            name: this.$t("legends.actualYear"),
            data: null,
          },
          {
            name: this.$t("legends.previousYear"),
            data: null,
          },
        ],
      },
      overYearChart: {
        options: {
          chart: {
            id: "airdna_overyear",
          },
          xaxis: {
            categories: null,
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return value.toLocaleString("fr-CH", {
                  style: "percent",
                  maximumFractionDigits: 2,
                });
              },
            },
            title: {
              text: this.$t("legends.evoPercent"),
            },
          },
          plotOptions: {
            bar: {
              dataLabels: {
                position: "top", // top, center, bottom
              },
            },
          },
          dataLabels: {
            enabledOnSeries: [0],
            offsetY: -15,
            style: {
              colors: ["#000"],
              fontSize: ".7rem",
            },
            formatter: function (val) {
              return val.toLocaleString("fr-CH", {
                style: "percent",
                maximumFractionDigits: 2,
              });
            },
          },
          colors: ["#0984e3"],
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
        type: "bar",
        data: [
          {
            name: this.$t("hesta.evolution"),
            data: null,
          },
        ],
      },
      objectsAvailability: {
        data: null,
        type: "pie",
        chartOptions: {
          chart: {
            id: "airdna_objects_availability",
            height: 250,
            type: "pie",
            toolbar: {
              show: false,
              tools: {
                download: false,
              },
            },
          },
          labels: null,
          legend: {
            position: "bottom",
          },
        },
      },
      rentalActivity: {
        data: null,
        type: "pie",
        chartOptions: {
          chart: {
            id: "airdna_rental_activity",
            height: 250,
            type: "pie",
            toolbar: {
              show: false,
              tools: {
                download: false,
              },
            },
          },
          labels: null,
          legend: {
            position: "bottom",
          },
        },
      },
    };
  },
  methods: {
    setParams(newParams) {
      this.params = newParams;
      this.refreshDemand();
    },
  },
};
</script>
